import { render, staticRenderFns } from "./eventUpdateModal.vue?vue&type=template&id=e761dbb2&scoped=true&"
import script from "./eventUpdateModal.vue?vue&type=script&lang=js&"
export * from "./eventUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e761dbb2",
  null
  
)

export default component.exports